/**
 * DCC专员跟进 - 待跟进
 */
export default {
  field_from_api: {
    today_follow_up: {
      name: '今日待跟进'
    },
    today_to_arrive: {
      name: '今日待到店'
    },
    all_follow_up: {
      name: '全部待跟进'
    },
    all_to_arrive: {
      name: '全部待到店'
    }
  },
  getData (params = {}) {
    this.$rest.dataAnalysis.getDccClueFollowUp(params).then(res => {
      if (res.code === 0) {
        this.dataList = res.data
      } else {
        this.showToast(res.message)
      }
    })
  }
}
